export default __webpack_public_path__ + "static/media/cancer9.e6c19462.jpg";